import { useState, useEffect } from 'react';
import * as d3 from 'd3';

export const useDataFetch = (endpoint) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const isDev = window.location.hostname === "localhost";

            // In production, check if we have preloaded data
            if (!isDev && window.hasPreloadData && window.preloadedData) {
                setData(window.preloadedData);
                setLoading(false);

                // Clear preloaded data after using it once
                window.preloadedData = null;
                window.hasPreloadData = false;
                return;
            }

            // Fetch from API (dev or no preload)
            try {
                const response = await d3.json(endpoint);
                setData(response);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchData();
    }, [endpoint]);

    return { data, loading, error };
};